module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Salas-2.e89e1497.png";